import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchDeliveryProcesses(service_provider_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/list_processes`
    );
  },
};
